import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';
import W2Federal from '../views/wage-forms/w2-federal';
import W2State from '../views/wage-forms/w2-state';
import Form1099NEC from '../views/1099-forms/1099-nec';
import Form1099MISC from '../views/1099-forms/1099-misc';
import Form1099INT from '../views/1099-forms/1099-int';
import Form1095B from '../views/aca-forms/1095-b';
import Form1095C from '../views/aca-forms/1095-c';
import Form1099DIV from '../views/1099-forms/1099-div';
import Form1099R from '../views/1099-forms/1099-r';
import Form1099S from '../views/1099-forms/1099-s';
import Form1099B from '../views/1099-forms/1099-b';
import Form1099K from '../views/1099-forms/1099-k';
import Form1099C from '../views/1099-forms/1099-c';
import Form1099G from '../views/1099-forms/1099-g';
import Form1099PATR from '../views/1099-forms/1099-patr';
import Form940 from '../views/payroll-forms/940';
import Form941 from '../views/payroll-forms/941';
import Form944 from '../views/payroll-forms/944';
// import GuestGuard from '../utils/route-guard/GuestGuard';

// sample page routing
const Dashboard = Loadable(lazy(() => import('views/dashboard')));

// addressBook routing
const AddressBook = Loadable(lazy(() => import('views/adress-book')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: (
        // <AuthGuard>
        <MainLayout />
        // </AuthGuard>
    ),
    children: [
        {
            path: '/',
            element: <Dashboard />
        },
        {
            path: '/dashboard',
            element: <Dashboard />
        },
        {
            path: '/address-book',
            element: <AddressBook />
        },
        {
            path: '/w2/federal',
            element: <W2Federal />
        },
        {
            path: '/w2/state',
            element: <W2State />
        },
        {
            path: '/1099/nec',
            element: <Form1099NEC />
        },
        {
            path: '/1099/misc',
            element: <Form1099MISC />
        },
        {
            path: '/1099/int',
            element: <Form1099INT />
        },
        {
            path: '/1099/div',
            element: <Form1099DIV />
        },
        {
            path: '/1099/r',
            element: <Form1099R />
        },
        {
            path: '/1099/s',
            element: <Form1099S />
        },
        {
            path: '/1099/b',
            element: <Form1099B />
        },
        {
            path: '/1099/k',
            element: <Form1099K />
        },
        {
            path: '/1099/c',
            element: <Form1099C />
        },
        {
            path: '/1099/g',
            element: <Form1099G />
        },
        {
            path: '/1099/patr',
            element: <Form1099PATR />
        },
        {
            path: '/aca/1095b',
            element: <Form1095B />
        },
        {
            path: '/aca/1095c',
            element: <Form1095C />
        },
        {
            path: '/payroll/940',
            element: <Form940 />
        },
        {
            path: '/payroll/941',
            element: <Form941 />
        },
        {
            path: '/payroll/944',
            element: <Form944 />
        },
        {
            path: '/corrections',
            element: <Form944 />
        }
    ]
};

export default MainRoutes;
